(function () {
  var STORAGE_KEY = "web-quiet-house-v1";

  function boot() {
    var root = document.querySelector('.puzzle-page[data-puzzle="quiet-house"]');
    if (!root || root.getAttribute("data-booted") === "1") return;
    root.setAttribute("data-booted", "1");
    startPuzzle(root);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  function startPuzzle(root) {
    function q(id) { return root.querySelector("#" + id); }

    var nodes = {
      dek: q("dek"),
      seed: q("case-seed"),
      letter: q("letter"),
      clues: q("clue-list"),
      check: q("check"),
      reveal: q("reveal"),
      status: q("status"),
      grid: q("grid"),
      newCase: q("new-case"),
      modal: q("modal"),
      modalYes: q("modal-yes"),
      modalNo: q("modal-no"),
      spoil: q("spoil"),
      spoilYes: q("spoil-yes"),
      spoilNo: q("spoil-no"),
    };

    var state = null;

    function engine() { return globalThis.QuietHouse; }

    function randomSeed() {
      var buf = new Uint32Array(1);
      crypto.getRandomValues(buf);
      return buf[0];
    }

    function blankMarks() {
      var marks = [];
      for (var person = 0; person < 4; person++) {
        var row = [];
        for (var col = 0; col < 9; col++) row.push(0);
        marks.push(row);
      }
      return marks;
    }

    function blankPlay(puzzle) {
      return {
        version: puzzle.version,
        seed: puzzle.seed,
        people: puzzle.people,
        rooms: puzzle.rooms,
        items: puzzle.items,
        roomsOf: puzzle.roomsOf,
        itemsOf: puzzle.itemsOf,
        guilty: puzzle.guilty,
        clues: puzzle.clues,
        checked: puzzle.clues.map(function () { return false; }),
        marks: blankMarks(),
        revealed: false,
        checkedOnce: false,
      };
    }

    function save() {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    }

    function load() {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      engine().assertCase(parsed);
      var marks = blankMarks();
      if (Array.isArray(parsed.marks)) {
        for (var person = 0; person < 4; person++) {
          var row = parsed.marks[person];
          if (!Array.isArray(row)) continue;
          for (var col = 0; col < 9; col++) {
            var mark = row[col];
            if (mark === 1 || mark === 2) marks[person][col] = mark;
          }
        }
      }
      var play = blankPlay(parsed);
      play.checked = parsed.clues.map(function (_, i) { return Boolean(parsed.checked && parsed.checked[i]); });
      play.marks = marks;
      play.revealed = Boolean(parsed.revealed);
      play.checkedOnce = Boolean(parsed.checkedOnce);
      return play;
    }

    function deal(seed) {
      state = blankPlay(engine().createCase(seed));
      save();
      renderAll();
    }

    function renderLetter() {
      nodes.letter.replaceChildren();
      var paras = engine().introParagraphs();
      for (var i = 0; i < paras.length; i++) {
        var p = document.createElement("p");
        p.textContent = paras[i];
        nodes.letter.append(p);
      }
    }

    function renderClues() {
      nodes.clues.replaceChildren();
      state.clues.forEach(function (clue, index) {
        var li = document.createElement("li");
        var label = document.createElement("label");
        label.className = "clue";
        var input = document.createElement("input");
        input.type = "checkbox";
        input.checked = Boolean(state.checked[index]);
        input.disabled = state.revealed;
        input.addEventListener("change", function () {
          if (state.revealed) return;
          state.checked[index] = input.checked;
          save();
        });
        var span = document.createElement("span");
        span.textContent = clue.text;
        label.append(input, span);
        li.append(label);
        nodes.clues.append(li);
      });
    }

    function headerCell(text, className) {
      var cell = document.createElement("th");
      cell.textContent = text;
      if (className) cell.className = className;
      return cell;
    }

    function renderGrid() {
      nodes.grid.replaceChildren();
      var head = document.createElement("thead");
      var groups = document.createElement("tr");
      var corner = headerCell("", "name");
      corner.rowSpan = 2;
      groups.append(corner);
      var rooms = headerCell("Rooms", "group");
      rooms.colSpan = 4;
      groups.append(rooms);
      var things = headerCell("Things", "group");
      things.colSpan = 4;
      groups.append(things);
      var guilty = headerCell("Guilty", "group");
      guilty.rowSpan = 2;
      groups.append(guilty);
      var labels = document.createElement("tr");
      state.rooms.forEach(function (room, index) {
        labels.append(headerCell(room, index === 3 ? "split" : ""));
      });
      state.items.forEach(function (item, index) {
        labels.append(headerCell(item, index === 3 ? "split" : ""));
      });
      labels.append(headerCell(""));
      head.append(groups, labels);

      var body = document.createElement("tbody");
      for (var person = 0; person < 4; person++) {
        var row = document.createElement("tr");
        var name = document.createElement("td");
        name.className = "name";
        name.textContent = engine().fullName(state.people[person]);
        row.append(name);
        for (var col = 0; col < 9; col++) {
          var td = document.createElement("td");
          if (col === 3 || col === 7) td.className = "split";
          var button = document.createElement("button");
          button.type = "button";
          button.className = "cell";
          button.dataset.person = String(person);
          button.dataset.col = String(col);
          button.disabled = state.revealed;
          paintCell(button, state.marks[person][col]);
          td.append(button);
          row.append(td);
        }
        body.append(row);
      }
      nodes.grid.append(head, body);
    }

    function paintCell(button, mark) {
      button.classList.toggle("yes", mark === 1);
      button.classList.toggle("no", mark === 2);
      button.textContent = mark === 1 ? "●" : mark === 2 ? "×" : "";
      var person = engine().fullName(state.people[Number(button.dataset.person)]);
      var col = Number(button.dataset.col);
      var what = col < 4 ? state.rooms[col] : col < 8 ? state.items[col - 4] : "guilty";
      var word = mark === 1 ? "yes" : mark === 2 ? "no" : "blank";
      button.setAttribute("aria-label", person + ", " + what + ", " + word);
    }

    function renderChrome() {
      nodes.seed.textContent = "Case " + engine().caseLabel(state.seed);
      nodes.check.classList.toggle("ready", gridComplete());
      nodes.check.disabled = state.revealed;
      nodes.reveal.hidden = state.revealed;
    }

    function renderAll() {
      document.title = engine().TITLE;
      nodes.dek.textContent = engine().DEK;
      renderLetter();
      renderClues();
      renderGrid();
      renderChrome();
      if (!state.revealed && !state.checkedOnce) nodes.status.textContent = "";
    }

    function setStatus(text, kind) {
      nodes.status.textContent = text;
      nodes.status.className = kind || "";
    }

    function openModal() {
      nodes.modal.hidden = false;
      nodes.modalNo.focus();
    }

    function closeModal() {
      nodes.modal.hidden = true;
      nodes.newCase.focus();
    }

    function openSpoil() {
      nodes.spoil.hidden = false;
      nodes.spoilNo.focus();
    }

    function closeSpoil() {
      nodes.spoil.hidden = true;
      nodes.reveal.focus();
    }

    function hasMarks() {
      if (state.revealed || state.checkedOnce || state.checked.some(Boolean)) return true;
      for (var person = 0; person < 4; person++) {
        for (var col = 0; col < 9; col++) if (state.marks[person][col]) return true;
      }
      return false;
    }

    function gridComplete() {
      var guilty = 0;
      for (var person = 0; person < 4; person++) {
        var rooms = 0;
        var items = 0;
        for (var col = 0; col < 4; col++) if (state.marks[person][col] === 1) rooms++;
        for (var col = 4; col < 8; col++) if (state.marks[person][col] === 1) items++;
        if (state.marks[person][8] === 1) guilty++;
        if (rooms !== 1 || items !== 1) return false;
      }
      return guilty === 1;
    }

    function selectionMatches() {
      var guilty = -1;
      for (var person = 0; person < 4; person++) {
        var room = -1;
        var item = -1;
        for (var col = 0; col < 4; col++) if (state.marks[person][col] === 1) room = col;
        for (var col = 4; col < 8; col++) if (state.marks[person][col] === 1) item = col - 4;
        if (room !== state.roomsOf[person] || item !== state.itemsOf[person]) return false;
        if (state.marks[person][8] === 1) guilty = person;
      }
      return guilty === state.guilty;
    }

    function showAnswer() {
      for (var person = 0; person < 4; person++) {
        for (var col = 0; col < 4; col++) state.marks[person][col] = state.roomsOf[person] === col ? 1 : 2;
        for (var col = 0; col < 4; col++) state.marks[person][col + 4] = state.itemsOf[person] === col ? 1 : 2;
        state.marks[person][8] = person === state.guilty ? 1 : 2;
      }
      state.revealed = true;
    }

    nodes.newCase.addEventListener("click", function () {
      if (hasMarks()) openModal();
      else deal(randomSeed());
    });

    nodes.modalYes.addEventListener("click", function () {
      closeModal();
      setStatus("Drawing a new case…", "");
      window.setTimeout(function () { deal(randomSeed()); }, 30);
    });

    nodes.modalNo.addEventListener("click", closeModal);
    nodes.modal.addEventListener("click", function (event) {
      if (event.target === nodes.modal) closeModal();
    });

    nodes.reveal.addEventListener("click", openSpoil);
    nodes.spoilYes.addEventListener("click", function () {
      closeSpoil();
      showAnswer();
      setStatus(engine().trioPhrase(state), "ok");
      save();
      renderClues();
      renderGrid();
      renderChrome();
    });
    nodes.spoilNo.addEventListener("click", closeSpoil);
    nodes.spoil.addEventListener("click", function (event) {
      if (event.target === nodes.spoil) closeSpoil();
    });

    root.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      if (!nodes.spoil.hidden) closeSpoil();
      else if (!nodes.modal.hidden) closeModal();
    });

    nodes.grid.addEventListener("click", function (event) {
      var button = event.target.closest(".cell");
      if (!button || state.revealed) return;
      var person = Number(button.dataset.person);
      var col = Number(button.dataset.col);
      state.marks[person][col] = (state.marks[person][col] + 1) % 3;
      paintCell(button, state.marks[person][col]);
      save();
      renderChrome();
    });

    nodes.check.addEventListener("click", function () {
      if (state.revealed) return;
      if (!gridComplete()) {
        setStatus("Mark one room and one thing for each person, and mark one guilty person.", "");
        return;
      }
      state.checkedOnce = true;
      if (selectionMatches()) {
        state.revealed = true;
        setStatus("Yes. " + engine().trioPhrase(state), "ok");
        renderClues();
        renderGrid();
      } else {
        setStatus("No. That grid does not fit every note.", "bad");
      }
      save();
      renderChrome();
    });

    nodes.dek.textContent = engine().DEK;
    try { state = load(); } catch (err) { state = null; }
    if (state) {
      renderAll();
      if (state.revealed) setStatus(engine().trioPhrase(state), "ok");
      return;
    }
    setStatus("Drawing the case…", "");
    window.setTimeout(function () {
      try {
        deal(randomSeed());
        setStatus("", "");
      } catch (err) {
        setStatus("The case could not be drawn. Reload the page to try again.", "bad");
      }
    }, 30);
  }
})();
